import './includes/polyfills'
import './includes/focus'

// The different components are imported here.
// import './components/example'

jQuery(document).ready(function($){
	var breakpoint_lg = 1200;
	var breakpoint_md = 992;
	var breakpoint_sm = 768;
	var breakpoint_xs = 576;

	const $window = $(window);
	
	/* Nav Toggle */
	$('.nav-wrapper .menu-button').on('click', function(e) {
		if ($('#main-nav-menu').is(':visible')) {
			$('#main-nav-menu').slideUp();
		} else {
			$('#main-nav-menu').slideDown();
		}
	});
	$('.dropdown-parent').on('click', function(e) {
		if($window.width() <= breakpoint_md) {

			if ($(this).find('ul').is(':visible')) {
				$(this).find('ul').slideUp();
			} else {
				$('.dropdown-parent > ul').slideUp();
				$(this).find('ul').slideDown();
			}
		}
	});
	$('.dropdown-parent > a:not([href]), .dropdown-parent > .theme-icon').on('click', function(e) {
		if($window.width() <= breakpoint_md) {
			e.stopPropagation();
			if ($(this).siblings('ul').is(':visible')) {
				$(this).siblings('ul').slideUp();
			} else {
				$('.dropdown-parent > ul').slideUp();
				$(this).siblings('ul').slideDown();
			}
		}
	});
	/* Hero Slider */
	$('.intro-hero').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 10000,
		appendDots: $('.slide-dot-nav'),
		ssEase: 'linear',
		dots: true,
		dotsClass: 'slide-dots',
		fade: true,
		lazyLoad: 'ondemand',
		slidesToShow: 1,
		slidesToScroll: 1
	});
	/* Featured Products */
	$('.featured-products').slick({
		lazyLoad: 'ondemand',
		prevArrow: '<button type="button" class="slick-btn btn-prev"><i class="ti ti-chevron-left"></i></button>',
		nextArrow: '<button type="button" class="slick-btn btn-next"><i class="ti ti-chevron-right"></i></button>',
		slidesToShow: 5,
		infinite: true,
		responsive: [
			{ breakpoint: 1200,
				settings: {
					slidesToShow: 4
				}
			},
			{ breakpoint: breakpoint_md,
				settings: {
					slidesToShow: 3
				}
			},
			{ breakpoint: breakpoint_sm,
				settings: {
					slidesToShow: 2
				}
			},
			{ breakpoint: breakpoint_xs,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
	/* Goals Slider */
	$('.goals-slider').slick({
		appendDots: $('.goals-block .block-content-footer'),
		dots: true,
		dotsClass: 'slide-dots',
		prevArrow: '',
		nextArrow: '<button type="button" class="slick-btn btn-prev"><i class="ti ti-chevron-right"></i></button>',
		slidesToShow: 2,
		responsive: [
			{ breakpoint: breakpoint_lg,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{ breakpoint: breakpoint_md,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{ breakpoint: breakpoint_sm,
				settings: 'unslick'
			}
		]
	});
	/* Customer Slider */
	$('.customer-slider').slick({
		prevArrow: '<button type="button" class="slick-btn btn-prev"><i class="ti ti-chevron-left"></i></button>',
		nextArrow: '<button type="button" class="slick-btn btn-prev"><i class="ti ti-chevron-right"></i></button>',
		slidesToShow: 4,
		infinite: true,
		autoplay: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: breakpoint_md,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1
				}
			}
/*
			{ breakpoint: 992,
				settings: {
					variableWidth: false,
					slidesToShow: 1
				}
			},
			{ breakpoint: 768,
				settings: {
					variableWidth: false,
					slidesToShow: 2
				}
			},
*/
			// { breakpoint: breakpoint_xs,
			// 	settings: {
			// 		variableWidth: false,
			// 		slidesToShow: 1
			// 	}
			// }
		]
	});
	
	/* Homepage Tabbed Area */
	$('ul.tab-links li').on('click', function(e) {
		if (!$(this).is('.active')) {
			$('ul.tab-links li').each(function(){
				$(this).removeClass('active');
			}).end();
			$('.tabbed-area .tab-panel').each(function(){
				$(this).removeClass('active');
			}).end();
			var showPanel = $(this).attr('class');
			$(this).addClass('active');
			$('.tabbed-area .tab-panel[data-target="' + showPanel + '"]').addClass('active');
		}
	});

	/* Secondary */
	$('#toggle-customer-list').on('click', function(e) {
		var minHeight = $("ul.customer-grid").css('min-height');
		if ($('ul.customer-grid').hasClass('expanded')) {
			$(this).html('View More');
			$('ul.customer-grid').removeClass('expanded').attr('style', '');
		} else {
			$(this).html('View Less');
			$('ul.customer-grid').addClass('expanded').css('max-height', '3000px');
		}
	});
	$('#_f_product_selection').on('change', function(e) {
		var theTab = $('#_f_product_selection :selected').parent().attr('label');
		$('#selected_group').val(theTab);

		$('.form-tabs .tab').removeClass('active');
		$('.form-tabs .tab-content').removeClass('active');

		$('.form-tabs .tab[data-tab="' + theTab + '"]').addClass('active');
		$('.form-tabs .tab-content[data-tab-content="' + theTab + '"]').addClass('active');
	});
	$('.form-tabs .tabs-list .tab').on('click', function(e) {
		console.log('hey');
		$(this).parent().find('.tab').removeClass('active');
		$(this).closest('.form-tabs').find('.tab-area .tab-content').removeClass('active')

		var showPanel = $(this).data('tab');
		$(this).addClass('active');
		$(this).closest('.form-tabs').find('.tab-area .tab-content[data-tab-content="' + showPanel + '"]').addClass('active');

		$('#selected_group').val(showPanel);
		$('#_f_product_selection option').removeAttr('selected');
		$('#_f_product_selection optgroup[label="' + showPanel + '"] option:first').prop('selected', true);
	});
	if ($('#selected_group').is(':visible')) {
		if (window.location.hash) {
			var theHash = window.location.hash;
			switch (theHash) {
				case '#Pressure-Washers': {
					$('.form-tabs ul.tabs-list li[data-tab="Pressure Washers"]').trigger('click');
					break;
				}
				case '#Porta-Pads': {
					$('.form-tabs ul.tabs-list li[data-tab="Porta-Pads"]').trigger('click');
					break;
				}
				case '#Water-Treatment': {
					$('.form-tabs ul.tabs-list li[data-tab="Water Treatment"]').trigger('click');
					break;
				}
				default: {
					// Do nothing
				}
			}
		}
	}
	$('#product-tabs ul.nav-tabs li').on('click', function(e) {
		e.preventDefault();
		if (!$(this).is('.active')) {
			$(this).parent().find('li').each(function(){
				$(this).removeClass('active');
			}).end();
			$('#product-tabs').find('.tab-content .tab-pane').each(function(){
				$(this).removeClass('active');
			}).end();
			var showPanel = $(this).find('a').attr('href');
			$(this).addClass('active');
			console.log(showPanel);
			$('#product-tabs').find('.tab-content .tab-pane' + showPanel).addClass('active');
		}
	});

	if($('#question_tab').length && window.location.hash === '#question_tab') {
		$('#question_tab a').click();
	}

	$('.product-filter-toggle').click('click', function (e) {
		e.preventDefault();
		$('#filters').slideToggle();
	});

	// Add header height as css var.
	var $body = $('body');
	var $header = $('body > header');
	function setMenuHeightVar() {
		console.log('setting menu height', $header.height());
		$body.get(0).style.setProperty('--header-height', $header.height() + 'px');
	}

	// Do this on page load
	setMenuHeightVar();

	// Do this on resize
	window.addEventListener('resize', event => {
		setMenuHeightVar();
	});
});
